import type { SVGProps } from "react";

export default function ChatIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0001 18.3327C14.6024 18.3327 18.3334 14.6017 18.3334 9.99935C18.3334 5.39697 14.6024 1.66602 10.0001 1.66602C5.39771 1.66602 1.66675 5.39697 1.66675 9.99935C1.66675 11.3324 1.97976 12.5923 2.5363 13.7098C2.6842 14.0067 2.73342 14.3461 2.64768 14.6665L2.15134 16.5216C1.93587 17.3268 2.67259 18.0635 3.47787 17.8481L5.33291 17.3518C5.65336 17.266 5.99276 17.3153 6.28969 17.4631C7.40706 18.0197 8.667 18.3327 10.0001 18.3327Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M6.66699 8.75H13.3337"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M6.66699 11.666H11.2503"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
